import { ComponentType } from 'react';
import { PerformanceTier } from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';
import { KalepIcon } from '@bolteu/kalep-react-icons/dist/types';
import ArrowDown from '@bolteu/kalep-react-icons/dist/ArrowDown';
import Cross from '@bolteu/kalep-react-icons/dist/Cross';
import goldMagnifierIcon from './assets/icon-magnifier-gold.png';
import silverMagnifierIcon from './assets/icon-magnifier-silver.png';
import goldLaurelsIcon from './assets/icon-laurels-gold.png';
import goldPercentFlowerIcon from './assets/icon-percent-flower-gold.png';
import silverPercentFlowerIcon from './assets/icon-percent-flower-silver.png';
import goldMegaphoneIcon from './assets/icon-megaphone-gold.png';
import silverMegaphoneIcon from './assets/icon-megaphone-silver.png';

export type TierBenefitId =
  | 'boostedHomeScreenVisibility'
  | 'regularHomeScreenVisibility'
  | 'reducedHomeScreenVisibility'
  | 'noHomeScreenVisibility'
  | 'boltStarFeatures'
  | 'boltFundedPromotions'
  | 'noCustomBoltFundedPromotions'
  | 'noPromotions'
  | 'sponsoredListings'
  | 'noSponsoredListings';

export interface TierBenefit {
  id: TierBenefitId;
  icon: string | ComponentType<KalepIcon>;
}

export const TIER_BENEFITS: Record<PerformanceTier, TierBenefit[]> = {
  poor: [
    { id: 'noSponsoredListings', icon: Cross },
    { id: 'noPromotions', icon: Cross },
    { id: 'noHomeScreenVisibility', icon: ArrowDown },
  ],
  needs_improvement: [
    { id: 'reducedHomeScreenVisibility', icon: ArrowDown },
    { id: 'noCustomBoltFundedPromotions', icon: Cross },
  ],
  good: [
    { id: 'regularHomeScreenVisibility', icon: silverMagnifierIcon },
    { id: 'boltFundedPromotions', icon: silverPercentFlowerIcon },
    { id: 'sponsoredListings', icon: silverMegaphoneIcon },
  ],
  top: [
    { id: 'boostedHomeScreenVisibility', icon: goldMagnifierIcon },
    { id: 'boltStarFeatures', icon: goldLaurelsIcon },
    { id: 'boltFundedPromotions', icon: goldPercentFlowerIcon },
    { id: 'sponsoredListings', icon: goldMegaphoneIcon },
  ],
};
